import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getBrandConfigurationReport(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brands_integration`,
    oauthTokenHeader
  );
}

function getBrandConfigPIECharts(
  oauthTokenHeader: string,
  website_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/5708300221939712/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
}

function getBrandBackendRequirements(
  oauthTokenHeader: string,
  backend_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/fetcher/backend_requirements/${backend_shared_uid}/`,
    oauthTokenHeader
  );
}

function getBrandProperties(
  oauthTokenHeader: string,
  brand_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/partners/affiliate_accounts/brand_properties/${brand_shared_uid}/`,
    oauthTokenHeader
  );
}

function editBrandProperties(oauthTokenHeader: string, data: any, brand_shared_uid: any) {
  return fetchWrapper.put(
    `${apiUrl}/partners/affiliate_accounts/brand_properties/${brand_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function postBrandConfigurationReport(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/partners/affiliate_accounts/brands_integration`,
    data,
    oauthTokenHeader
  );
}

export const brandConfigReportService = {
  getBrandConfigurationReport,
  getBrandConfigPIECharts,
  getBrandBackendRequirements,
  getBrandProperties,
  editBrandProperties,
  postBrandConfigurationReport
};
